import(/* webpackMode: "eager", webpackExports: ["loader"] */ "/vercel/path0/apps/store-vercel/src/lib/loader.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@19_t7gk7jqkblrv2ydw2mgnor47ki/node_modules/next/dist/client/image-component.js");
